<div class="package">
  <!-- package / details -->
  <div class="package__focus">
    <div class="row">
      <div class="col-6 col-md-6 col-lg-9 align-self-center">
        <span class="package__name">{{ package.name }}</span>
      </div>
      <div class="col-6 col-md-6 col-lg-3 pl-none text-right">
        <div class="package__label">total repayments</div>
        <div class="package__text">
          {{ totalRepayments | currency: '':'symbol-narrow':'1.0-0' }}
        </div>
      </div>
    </div>
  </div>

  <!-- package / products -->
  <div class="package__products">
    <ul class="product__list">
      <li class="product__item" *ngFor="let packageProduct of package.products">
        <app-product-selection-product
          [product]="packageProduct.product"
          [isPackaged]="true"></app-product-selection-product>
      </li>
    </ul>
  </div>
</div>
